var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"main",staticClass:"kd-layout-fixed-bottom"},[_c('div',{staticClass:"kd-layout-fixed-bottom__main"},[_vm._t("default")],2),(_vm.$slots.footer)?_c('div',{ref:"footer",staticClass:"kd-layout-fixed-bottom__footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }